import { TRegistrationStepsGeorgia } from "@/types/registrationGe.types";
import { AccountType } from "@/enums/registrationSteps.enum";
import { privateStepsGe } from "@/configs/registrationSteps/Ge/PrivateStepsGe";
import { companyStepsGe } from "@/configs/registrationSteps/Ge/CompanyStepsGe";

export const registrationStepsDataGeorgia: TRegistrationStepsGeorgia = {
  [AccountType.private]: privateStepsGe,
  [AccountType.company]: companyStepsGe,
};
